import React from "react";
import { useParams, Link } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero } from "../components/Section";
import { useApp } from "../context/AppContext";
import { useReveal } from "../hooks/useReveal";
import { regionsData } from "../data/regionsData";
import { ArrowLeft, MapPin, Grape } from "lucide-react";

const RegionDetail = () => {
  const { id } = useParams();
  const { lang, t } = useApp();
  const region = regionsData.find((r) => r.id === id) || regionsData[0];
  useReveal([id]);

  const name = lang === "de" ? region.name : region.nameEn;
  const jsonLd = {
    "@context": "https://schema.org", "@type": "Place", name, description: region.intro[lang], image: region.img,
  };

  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={`${name} — ${lang === "de" ? "Weinregion" : "Wine Region"}`} description={region.intro[lang]} image={region.img} path={`/regions/${region.id}`} lang={lang} jsonLd={jsonLd} />
      <PageHero title={name} subtitle={region.intro[lang].slice(0, 120) + "…"} image={region.img} />
      <div className="max-w-4xl mx-auto px-6 py-14">
        <Link to="/regions" className="inline-flex items-center gap-1.5 text-wine hover:text-wine-dark text-sm font-medium mb-6"><ArrowLeft className="w-4 h-4" /> {t("regions.title")}</Link>
        <p className="text-ink/80 text-lg leading-relaxed reveal">{region.intro[lang]}</p>
        <h2 className="font-serif text-3xl text-wine mt-12 mb-6 reveal">{lang === "de" ? "Unterregionen" : "Sub-regions"}</h2>
        <div className="grid sm:grid-cols-2 gap-5">
          {region.subregions.map((s, i) => (
            <div key={i} className="reveal bg-white rounded-2xl border border-border p-6 hover:shadow-lg transition-all">
              <h3 className="font-serif text-xl text-ink flex items-center gap-2"><Grape className="w-5 h-5 text-gold" /> {s.name}</h3>
              <p className="mt-2 text-ink/65 leading-relaxed text-sm">{s.desc[lang]}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegionDetail;
